module.exports = __webpack_public_path__ + "img/nc.9eea5370.svg";